var header = function () {

    var last_known_scroll_position = 0;
    var ticking = false;

    var header          = document.getElementById('shopify-section-header'),
        stickyHeader    = document.querySelector('.header.header--sticky'),
        scrollingNav    = document.querySelector('.scrolling-nav-container.scrolling-nav--global'),
        stickyAnnouncementBar = document.querySelector('.announcement-bar-sticky'),
        productStickyForm = document.querySelector('.product-sticky-form');

    const scrollingAccNav = document.querySelector('.account-dashboard__menu-container');
    const searchTrigger = document.querySelector('.nav--header__search-trigger');
    const scrollThreshold = 500;
    let lastScrollPosition = 0;

    var toggleHeader = function(direction, curScroll) {
        if ( window.pageYOffset > header.offsetHeight ) { 
            if( document.querySelector('body').classList.contains('no--scroll') ){
                return;
            }
            header.classList.add('is--fixed');
        }else{
            header.classList.remove('is--fixed');
        }
    };

    var setStickyFormTop = function() {
        if (stickyAnnouncementBar) {
            scrollingNav ? scrollingNav.style.top = '76px' : '';
            productStickyForm ? productStickyForm.style.top = '90px' : '';
        } else {
            scrollingNav ? scrollingNav.style.top = '50px' : '';
            productStickyForm ? productStickyForm.style.top = '60px' : '';
        }
        
        if (stickyAnnouncementBar) {
            let stickyAnnouncementBarHeight = stickyAnnouncementBar.offsetHeight;
            let stickyHeaderHeight = stickyHeader.offsetHeight;
            let top = stickyAnnouncementBarHeight + stickyHeaderHeight;
            productStickyForm ? productStickyForm.style.top = `${top}px` : '';
        } else {
            let stickyHeaderHeight = stickyHeader.offsetHeight;
            let top = stickyHeaderHeight;
            productStickyForm ? productStickyForm.style.top = `${top}px` : '';
        }
    };

    let toggleStickyHeader = function() {
        const scrollPosition = window.scrollY;
        const headerHeight = header.offsetHeight;

        if (scrollPosition < lastScrollPosition || scrollPosition < headerHeight) {
            header.classList.add('sticky');

            if (scrollingNav) {
                scrollingNav.classList.add('sticky');
            }

            if (scrollingAccNav) {
                scrollingAccNav.classList.add('sticky');
            }
        } else if (scrollPosition > lastScrollPosition && scrollPosition > headerHeight + scrollThreshold) {
            header.classList.remove('sticky');

            if (scrollingNav) {
                scrollingNav.classList.remove('sticky');
            }

            if (scrollingAccNav) {
                scrollingAccNav.classList.remove('sticky');
            }
        }

        lastScrollPosition = scrollPosition;
    }

    let handleMutationObserver = function(){

        const resizeObserver = new ResizeObserver(entries => {
                        
            entries.forEach(entry => {
                document.documentElement.style.setProperty('--bx-creative-height', `${document.querySelector('.bx-wrap').offsetHeight}px`);
            });
        });
        
        const elementCheck = document.querySelector('body');
        
        const observer = new MutationObserver(function() {
            
            if( document.querySelector('.bx-creative') ){

                const creative = document.querySelector('.bx-creative');

                if( creative.style.backgroundColor == undefined || creative.style.backgroundColor == null ) return;

                console.log("PREVIOUS SIBLING: ", header.previousElementSibling);

                const previousSiblingBottom = header.previousElementSibling.getBoundingClientRect().bottom;
                
                console.log("Previous Sibling BOTTOM: ", previousSiblingBottom);

                document.documentElement.style.setProperty('--bx-creative-height', `${document.querySelector('.bx-creative').offsetHeight}px`);

                resizeObserver.observe(creative);

                    // if (stickyAnnouncementBar) {
                    //     let stickyAnnouncementBarHeight = stickyAnnouncementBarHeight.offsetHeight;
                    //     let headerHeight = header.offsetHeight;
                    //     let bxWrapHeight = document.querySelector('.bx-wrap').offsetHeight;
                    //     let top = stickyAnnouncementBarHeight + headerHeight + bxWrapHeight;
                    //     productStickyForm ? productStickyForm.style.top = `${top}px` : '';
                    // } else {
                    //     let headerHeight = header.offsetHeight;
                    //     let bxWrapHeight = document.querySelector('.bx-wrap').offsetHeight;
                    //     let top = headerHeight + bxWrapHeight;
                    //     productStickyForm ? productStickyForm.style.top = `${top}px` : '';
                    // }

                observer.disconnect();
            }
        });

        observer.observe(elementCheck, {
            childList: true,
            subtree:   true
        });
    }

    var listeners = function (){

        // handleMutationObserver();
        
        window.addEventListener('scroll', function(e){
            setStickyFormTop();
            if(window.innerWidth <= 768) {
                toggleStickyHeader();
            }
            
            last_known_scroll_position = window.scrollY;
            
            if (!ticking) {
                window.requestAnimationFrame(function() {
                    toggleHeader();
                    ticking = false;
                });

                ticking = true;
            }
        });

        searchTrigger.addEventListener('click', () => {
            header.classList.toggle('search-open');
        });
    };

    listeners();

}();

function closeDropdown(e) {
    e.target.closest('.nav__dropdown').style.display = 'none';
    e.target.closest('.nav--header__item').querySelector('.nav__dropdown-trigger').setAttribute('aria-expanded', 'false');
}

function openDropdown(e) {
    e.target.closest('.nav--header__item').querySelector('.nav__dropdown').style.display = 'block';
    let triggers = e.target.closest('.nav--header').querySelectorAll('.nav__dropdown-trigger');
    for(let i = 0; i < triggers.length; i++) {
        triggers[i].setAttribute('aria-expanded', 'false');
    }
    e.target.closest('.nav--header__item').querySelector('.nav__dropdown-trigger').setAttribute('aria-expanded', 'true');
}